import * as React from 'react';
import { TroughModel } from 'franke-trough-dependencies';
import { TroughQtyAdd, TroughQtyRemove } from '../index';

import './SelectedTroughListItem.scss';
import TroughQtyPartial from '../TroughQty/TroughQty';
import TroughImage from '../TroughImage/TroughImage';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './SelectTroughListItem.messages';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { WarningsTooltip } from '../../Configuration';
import ConsolesOverlapChoice from 'src/app/Partials/Configuration/Inputs/Assemblies/ConsoleOverlapChoice';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface SelectedTroughListItemProps {
  configuration: GlobalPrivateState['configuration'];
  trough: TroughModel;
}

export class SelectedTroughListItemPartial extends React.Component<SelectedTroughListItemProps, any> {
  public render() {
    const { trough } = this.props;
    
    return (
      <div className="partial-trough-list-item col-12">
        <div className="trough-list-item-inner border-bottom">
          <div className="row">
            <div className="col-12 trough-heading pt-2 pb-2">
              <div className="row">
                <div className="col-6 text-left">
                  <h6 className="font-weight-bold">{trough.name}</h6>
                </div>
                <div className="col-6 text-right position-relative">

                  {isConfigurationEditable() && (
                    <>
                      <WarningsTooltip itemKey="qty" />
                      <TroughQtyAdd troughId={trough.id} />
                      <TroughQtyRemove troughId={trough.id} />
                    </>
                  )}
                  <div className="d-inline-flex align-items-center justify-content-end">
                    <TroughQtyPartial troughId={trough.id} />
                    <span className="ml-2 d-inline-flex align-items-center">
                      <ConsolesOverlapChoice id={`trough_qty_overlap_${trough.id}`} inline={true} />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-3 trough-image pb-4">
              <div className="row">
                <div className="col-12">
                  <img src={`https://kwcws3d.blob.core.windows.net/cdn/images/troughs/${trough.fileName}.png`} className="img-fluid" alt={trough.name} />
                </div>
              </div>              
            </div>

            <div className="col-9 trough-data">
              <div className="row">
                <div className="col-4 text-left">
                  <small><FormattedMessage {...MESSAGES.selectedTroughListItemWidth} /></small>
                  <p>{trough.throughWidth} mm</p>
                </div>
                <div className="col-4 text-left">
                  <small><FormattedMessage {...MESSAGES.selectedTroughListItemHeight} /></small>
                  <p>{trough.throughHeight} mm</p>
                </div>
                <div className="col-4 text-left">
                  <small><FormattedMessage {...MESSAGES.selectedTroughListItemDepth} /></small>
                  <p>{trough.throughDepth} mm</p>
                </div>
                <div className="col-12 text-left">
                  <small><FormattedMessage {...MESSAGES.selectedTroughListItemMinDimensions} /></small>
                  <p>{trough.minPlateWidth} mm x {trough.plateDepth.min} mm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const SelectedTroughListItem = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(SelectedTroughListItemPartial);

export default SelectedTroughListItem;
